import { Box, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useEffect } from "react";
import { getRole } from "../data/role.api";
import CustomTable from "../../../shared/CustomTable";
import { InterfaceRoleData } from "../data/role.interface";
import { Delete, Edit } from "@mui/icons-material";

export default function RoleTable(props: {
    onEdit?: (data: InterfaceRoleData) => void,
    onDelete?: (id: number) => void
}) {

    const dispatch = useDispatch<any>()

    const { roleList } = useSelector((state: RootState) => state.role)

    useEffect(() => {
        dispatch(getRole())
    }, [dispatch])

    return (
        <Box>
            <CustomTable
                columns={[
                    {
                        name: "Nama",
                        key: "name"
                    }
                ]}
                dataList={roleList}
                actionList={(props.onEdit || props.onDelete)
                    ? (data: InterfaceRoleData) => (
                        <Box display={"flex"} justifyContent={"center"} gap={1}>
                            {props.onEdit && (<Button startIcon={<Edit />} color="warning" onClick={() => props.onEdit && props.onEdit(data)}>Edit</Button>)}
                            {props.onDelete && (<Button startIcon={<Delete />} color="error" onClick={() => props.onDelete && props.onDelete(data.id)}>Hapus</Button>)}
                        </Box>
                    )
                    : undefined
                }
            />
        </Box>
    )
}